import { ShieldAccountOutlineIcon } from './ShieldAccountOutlineIcon';

/**
 * author: GreenTurtwig
 * id E74ADD51-598F-4194-868C-3A9F7B62BCFA
 * name shield-account-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-account-outline.svg
 * tags
 * - Account / User 
 * - Home Automation 
 */
export const AlarmArmHomeOutlineIcon = ShieldAccountOutlineIcon;
export default AlarmArmHomeOutlineIcon